import styles from './ErrorContent.module.scss';
import { ErrorModalContent } from 'components';
import { selectModalsErrors } from 'store/app/selectors';
import { useSelector } from 'store/utils';

type Props = {
  onConfirm(): void;
};

export const ErrorContent = ({ onConfirm }: Props) => {
  const errorMessage = useSelector(selectModalsErrors).editPatientError;
  return (
    <ErrorModalContent
      title="Information is not updated"
      subtitle={`The patient case information is not updated${errorMessage ? `. ${errorMessage}` : ' due to technical errors'}`}
      contentContainerClassname={styles.contentContainer}
      onConfirm={onConfirm}
    />
  );
};
